<template>
  <div class="notice-panel">
    <div class="notice-head">
      <span class="notice-title">消息通知</span>
      <div class="notice-head-actions">
        <span class="sound-toggle-label">声音</span>
        <el-switch
          :value="!soundMuted"
          size="mini"
          active-color="#00b42a"
          inactive-color="#c9cdd4"
          @change="$emit('sound-muted-change', !$event)"
        />
        <el-button type="text" size="mini" :loading="loading" @click="loadNotices">刷新</el-button>
      </div>
    </div>
    <div v-loading="loading" class="notice-body">
      <div v-if="!loading && !list.length" class="notice-empty">
        <i class="el-icon-message"></i>
        <p>暂无待处理告警</p>
      </div>
      <ul v-else class="notice-list">
        <li
          v-for="item in list"
          :key="item.alarmId"
          class="notice-item"
          @click="onItemClick(item)"
        >
          <div class="notice-item-top">
            <span class="notice-item-title">{{ item.title || '告警' }}</span>
            <gas-status-tag kind="alarmLevel" :value="item.alarmLevel" size="mini" />
          </div>
          <div class="notice-item-meta">
            <span v-if="item.terminalCode">终端 {{ item.terminalCode }}</span>
            <span>{{ item.alarmTime || '-' }}</span>
          </div>
        </li>
      </ul>
    </div>
    <div class="notice-foot">
      <el-button type="text" size="small" @click="goAll">查看全部告警</el-button>
    </div>
  </div>
</template>

<script>
import { gasApi } from '@/api/gas'

export default {
  name: 'HeaderNoticePanel',
  props: {
    soundMuted: { type: Boolean, default: false }
  },
  data() {
    return {
      loading: false,
      list: [],
      total: 0
    }
  },
  methods: {
    async loadNotices() {
      this.loading = true
      try {
        const res = await gasApi.alarm.list({
          pageNum: 1,
          pageSize: 8,
          alarmStatus: 'active',
          keyword: ''
        })
        const data = res.data || {}
        this.list = data.records || []
        this.total = Number(data.total || 0)
        this.$emit('count-change', this.total)
      } catch (e) {
        this.list = []
        this.total = 0
        this.$emit('count-change', 0)
      } finally {
        this.loading = false
      }
    },
    onItemClick() {
      this.$emit('navigate')
      this.$router.push('/alarm/realtime')
    },
    goAll() {
      this.$emit('navigate')
      this.$router.push('/alarm/realtime')
    }
  }
}
</script>

<style scoped>
.notice-panel {
  margin: -12px;
}
.notice-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 16px 8px;
  border-bottom: 1px solid #e5e6eb;
  gap: 12px;
}
.notice-title {
  font-size: 15px;
  font-weight: 600;
  color: #1d2129;
}
.notice-head-actions {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
.sound-toggle-label {
  font-size: 12px;
  color: #4e5969;
}
.notice-body {
  min-height: 120px;
  max-height: 320px;
  overflow-y: auto;
}
.notice-empty {
  padding: 32px 16px;
  text-align: center;
  color: #86909c;
  font-size: 13px;
}
.notice-empty i {
  font-size: 32px;
  margin-bottom: 8px;
}
.notice-empty p {
  margin: 0;
}
.notice-list {
  list-style: none;
  margin: 0;
  padding: 0;
}
.notice-item {
  padding: 12px 16px;
  border-bottom: 1px solid #f2f3f5;
  cursor: pointer;
  transition: background 0.15s;
}
.notice-item:hover {
  background: #f7f8fa;
}
.notice-item-top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 6px;
}
.notice-item-title {
  flex: 1;
  font-size: 14px;
  color: #1d2129;
  line-height: 1.4;
}
.notice-item-meta {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
  color: #86909c;
}
.notice-foot {
  padding: 8px 16px 12px;
  text-align: center;
  border-top: 1px solid #e5e6eb;
}
</style>
